import React from 'react'
import './TokenSaleBanner.scss'

function TokenSaleBanner() {
  return (
    <div className="w-full bg-black border-b border-walme-border">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center py-2 text-sm">
          <span className="text-walme-text">
            🔥 Join <strong className="text-walme-primary">$WLM</strong> token sale and get up to <strong className="text-walme-primary">30% Bonus</strong> in tokens
          </span>
          <a
            href="https://fundraising.walme.io"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-3 text-walme-primary hover:text-walme-primary-hover transition-colors font-semibold"
          >
            Explore more →
          </a>
        </div>
      </div>
    </div>
  )
}

export default TokenSaleBanner
